import { render, staticRenderFns } from "./ForgottenPassword.vue?vue&type=template&id=4b0c9f3c&"
import script from "./ForgottenPassword.vue?vue&type=script&lang=js&"
export * from "./ForgottenPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports